import {IContentMapper} from '../base.content';
import {
  PlayerListContent,
  PlayerListContentItem,
  PlayerListContentDTO,
  PlayerListContentItemDTO
} from '../player-list.content';
import {cmsTypeToString} from "../../constants";


export class PlayerListContentMapper implements IContentMapper {
  toDTO(data: PlayerListContent): PlayerListContentDTO {
    return {
      type: cmsTypeToString(data.type),
      label: data.label,
      items: data.items.toArray().map((item) : PlayerListContentItemDTO => ({
        player_id: item.player_id,
        primaryText: item.primaryText,
        secondaryText: item.secondaryText,
          // @ts-ignore
        avatar: item.avatar.original || item.avatar,
        number: item.number,
      }))
    };

  }

  fromDTO(data: PlayerListContentDTO): PlayerListContent {
    let content = new PlayerListContent({ label: data.label });
    data.items.map(rowData => {
      content = content.addPlayer(PlayerListContentItem.toPlayer(rowData));
    });
    return content;
  };
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/player-list.ts